module.exports = __webpack_public_path__ + "img/2023_dodge-hornet.d47aab8d.png";